import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {useReducer} from 'react'
const ActionTypes = {
  FAILURE,
  PENDING,
  SUCCESS,
}
const InitialState = {
  data: [],
  error: null,
  isLoading: false,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        groups: action.payload,
        data: action.payload,
      }
    case FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

const useGetEntityObjectsReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useGetEntityObjectsReducer
export {ActionTypes, InitialState, Reducer}
